import { addFilter } from '@situation/setdesign.util';

addFilter('content-slider/owl-settings', (settings) => ({
    ...settings,
    items: 1,
    nav: true,
    navText: [
        '<svg><use xlink:href="#icon-long-arrow"></use></svg>',
        '<svg><use xlink:href="#icon-long-arrow"></use></svg>',
    ],
    responsive: { 620: { margin: 20, items: 2 }, 1080: { margin: 40, items: 3 } },
}));
